<template>
  <div class="module introduce">
    <div class="container">
      <el-row :gutter="98">
        <el-col :span="15">
          <h3 class="module-title">{{introduceData.title}}</h3>
          <section class="module-text" v-for="(item,index) in introduceData.content" :key="index">
            <p>{{item}}</p>
          </section>
        </el-col>
        <el-col :span="9" style="margin-top:65px;">
          <img :src="introduceData.img" alt />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "introduce",
  props: {
    msg: String
  },
  data() {
    return {
      introduceData: {
        title: "飞讯构件式平台",
        content: [
          "飞讯软件根据十余年企业应用开发的实践经验积累，通过先进的组件化、配置化的设计理念，精心打造的一款快速开发平台，用于低门槛、高效率地进行企业中各种实用型管理软件的开发。以追求实用为目标，最大限度地降低开发的技术门槛和难度、提高开发效率、节省开发时间，让开发者只需要专注于业务逻辑的实现。",
          "通俗地来说，正如统一规格、统一标准的机器零部件，只需按要求简单的拼装即能成为完整的机械设备一样，即使不会软件开发编程技术的各行业从业人员，通过短期非脱产学习后，就能在最短的时间内，开发出软件并投入实际使用。还能根据自己的业务需求来改装设备就可高价出售。"
        ],
        img: require("../assets/images/getech/figure2.png")
      }
    };
  },
  created() {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.module {
  &.introduce {
    min-height: 500px;
    padding-top: 0;
    background:#fff;
    img {
      padding-top: 59px;
      width: 100%;
    }

    .module-title {
      margin-top: 139px;
    }
  }
}
</style>
